export const ConsumeColumns = [
    {
      accessor: "bankTransactionTime",
      header: "تاریخ",
    },
    {
      accessor: "depositPaymentVia",
      header: "از طریق",
    },
    {
      accessor: "creditorsLedger",
      header: "مبلغ",
    },
    
  ];
  